import { FC, useState } from 'react';
import styles from './styles.module.css';
import classNames from 'classnames';
import WorkTimesSelect from '../WorkTimesSelect';
import {
  date,
  driver,
  putDriver,
  putWorkTime,
  putWorkTimesRequest,
} from '../../../../types/workTime';

const workOptions = new Map([
  [1, '出勤'],
  [2, '全休'],
  [3, '午前休'],
  [4, '午後休'],
]);
type Props = {
  workTimes: driver[];
  month: string;
  workTimesChange: (text: putWorkTimesRequest) => void;
};
const EditingWorkTimesTable: FC<Props> = ({
  workTimes,
  month,
  workTimesChange,
}) => {
  const [changeWorkTimes, updateChangeWorkTimes] = useState<driver[]>();
  const [clickDriverId, updateClickDriverId] = useState<number>();
  const [clickDate, updateClickDate] = useState<string>();

  const changeDrivers: putDriver = {
    userId: null,
    workTimeId: null,
  };

  const changeDate: putWorkTime = {
    date: '',
    drivers: [],
  };

  const workTimesRequest: putWorkTimesRequest = {
    workTime: [],
  };

  const [workTimesRequestBody] =
    useState<putWorkTimesRequest>(workTimesRequest);

  const week = (date: number) => {
    const day = new Date(month.concat('/', String(date))).getDay();
    const weekStr = ['日', '月', '火', '水', '木', '金', '土'][day];
    return weekStr;
  };

  const getDays = () => {
    let monthStr = month.slice(-2);
    monthStr = monthStr.includes('/') ? monthStr.replace('/', '0') : monthStr;
    const getLastDate = new Date(
      Number(month.slice(0, 4)),
      Number(monthStr),
      0
    );
    const dayList = [];
    for (let i = 1; i <= getLastDate.getDate(); i++) {
      dayList.push(i);
    }
    return dayList;
  };

  const getIndex = (driverId: number, date: string, workTimes: driver[]) => {
    const changeDriverIdIndex = workTimes
      .map((value) => value.userId)
      .indexOf(driverId);
    if (changeDriverIdIndex === -1) return [changeDriverIdIndex, 0];
    const dateList = workTimes[changeDriverIdIndex].dates
      .map((value) => value.date)
      .indexOf(date);
    return [changeDriverIdIndex, dateList];
  };

  const makeRequestBody = (
    driverId: number,
    date: string,
    workInfo: number | null
  ) => {
    const workTimeResult = workTimesRequestBody.workTime.filter(
      (c) => c.date === date
    );

    if (workTimeResult.length === 0) {
      changeDrivers.userId = driverId;
      changeDrivers.workTimeId = workInfo;
      changeDate.date = date;
      changeDate.drivers.push(changeDrivers);
      workTimesRequestBody.workTime.push(changeDate);
    } else {
      const driverIdResult = workTimeResult[0].drivers.filter(
        (c) => c.userId === driverId
      );
      if (driverIdResult.length === 0) {
        const index = workTimesRequestBody.workTime
          .map((value) => value.date)
          .indexOf(date);
        changeDrivers.userId = driverId;
        changeDrivers.workTimeId = workInfo;
        workTimesRequestBody.workTime[index].drivers.push(changeDrivers);
      } else {
        const workTimeIndex = workTimesRequestBody.workTime
          .map((value) => value.date)
          .indexOf(date);
        const driverIndex = workTimesRequestBody.workTime[workTimeIndex].drivers
          .map((value) => value.userId)
          .indexOf(driverId);
        workTimesRequestBody.workTime[workTimeIndex].drivers[
          driverIndex
        ].workTimeId = workInfo === 0 ? null : workInfo;
      }
    }
    workTimesChange(workTimesRequestBody);
  };

  const onChangeWorkInfo = (
    driverId: number,
    date: string,
    workInfo: string
  ) => {
    const selectWorkInfo = workInfo ? Number(workInfo) : null;
    if (!changeWorkTimes || changeWorkTimes?.length === 0) {
      updateChangeWorkTimes([
        {
          userId: driverId,
          userNo: driverId,
          driverName: '',
          dates: [
            {
              date: date,
              workTime: {
                id: selectWorkInfo,
                name: workOptions.get(Number(workInfo)) || '',
              },
            },
          ],
        },
      ]);
    } else {
      const index = getIndex(driverId, date, changeWorkTimes);
      if (index[0] === -1) {
        updateChangeWorkTimes([
          ...changeWorkTimes,
          {
            userId: driverId,
            userNo: driverId,
            driverName: '',
            dates: [
              {
                date: date,
                workTime: {
                  id: selectWorkInfo,
                  name: workOptions.get(Number(workInfo)) || '',
                },
              },
            ],
          },
        ]);
      } else if (index[1] === -1) {
        updateChangeWorkTimes(
          changeWorkTimes.map((a, i) =>
            i !== index[0]
              ? a
              : {
                  ...a,
                  dates: [
                    ...changeWorkTimes[i].dates,
                    {
                      date: date,
                      workTime: {
                        id: selectWorkInfo,
                        name: workOptions.get(Number(workInfo)) || '',
                      },
                    },
                  ],
                }
          )
        );
      } else {
        const target = changeWorkTimes[index[0]].dates[index[1]];
        updateChangeWorkTimes(
          changeWorkTimes.map((a, i) =>
            i !== index[0]
              ? a
              : {
                  ...a,
                  dates: a.dates.map((b, j) =>
                    j !== index[1]
                      ? b
                      : {
                          ...target,
                          id: selectWorkInfo,
                          workTime: target.workTime
                            ? { ...target.workTime, id: selectWorkInfo }
                            : {
                                id: selectWorkInfo,
                                name: workOptions.get(Number(workInfo)) || '',
                              },
                        }
                  ),
                }
          )
        );
      }
    }
    makeRequestBody(driverId, date, selectWorkInfo);
  };

  const changeWorkInfo = (driverId: number, changeDate: date) => {
    let id = changeDate.workTime?.id ?? 0;
    if (changeWorkTimes && changeWorkTimes.length !== 0) {
      const driver = changeWorkTimes.filter(
        (driver) => driver.userId === driverId
      );
      if (driver.length !== 0) {
        const changeData = driver[0].dates.filter(
          (date) => date.date === changeDate.date
        );
        if (changeData.length !== 0) {
          id = changeData[0].workTime?.id ?? 0;
        }
      }
    }
    const possible = id < 2;
    return (
      <td
        className={classNames(
          styles.block,
          !possible && styles.isImpossibleDataCell
        )}
        key={driverId + changeDate.date}
      >
        <div
          className={classNames(
            id < 3
              ? possible
                ? styles.isPossibleMark
                : styles.isImpossibleMark
              : styles.isHalfImpossible,
            driverId === clickDriverId &&
              changeDate.date === clickDate &&
              styles.isSelected
          )}
        >
          <WorkTimesSelect
            isPossible={possible}
            value={id}
            onClick={() => {
              updateClickDriverId(driverId);
              updateClickDate(changeDate.date);
            }}
            onChange={(e) =>
              onChangeWorkInfo(driverId, changeDate.date, e.target.value)
            }
          />
        </div>
      </td>
    );
  };

  return (
    <table className={classNames(styles.table, 'rounded-corners')}>
      <thead>
        <tr className={styles.head}>
          <th className={classNames(styles.headCell, styles.center, styles.id)}>
            ID
          </th>
          <th className={classNames(styles.headCell, styles.name)}>名前</th>
          {getDays().map((i) => (
            <th
              key={i}
              className={classNames(
                styles.headCell,
                styles.center,
                styles.date,
                clickDate && Number(clickDate.substring(8, 11)) === i
                  ? styles.selectedBackground
                  : null
              )}
            >
              {i}({week(i)})
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {workTimes.map((workTime) => (
          <tr key={workTime.userId}>
            <td
              className={classNames(
                clickDriverId === workTime.userId
                  ? styles.selectedBackground
                  : styles.background,
                styles.dataCell,
                styles.front,
                styles.center
              )}
            >
              {workTime.userNo}
            </td>
            <td
              className={classNames(
                styles.dataCell,
                styles.front,
                clickDriverId === workTime.userId
                  ? styles.selectedBackground
                  : styles.background
              )}
            >
              <div className={styles.driverName}>{workTime.driverName}</div>
            </td>
            {workTime.dates.map((date) => {
              return changeWorkInfo(workTime.userId, date);
            })}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default EditingWorkTimesTable;
